module.exports = __webpack_public_path__ + "static/img/jkfa_icon.png";